import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { t, BRANCHES } from "../lib/i18n";
import Logo from "./Logo";

export const Footer = () => {
  const { lang, tr } = useLang();
  return (
    <footer className="border-t border-slate-200 bg-white mt-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-1">
          <Logo />
          <p className="mt-4 text-sm text-slate-600 leading-relaxed">
            {tr({ en: "Local, honest CSC services in Bihar. Aadhaar, PAN, passport, EPF and more.", hi: "बिहार में स्थानीय, ईमानदार CSC सेवाएँ। आधार, पैन, पासपोर्ट, EPF और भी बहुत कुछ।" })}
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.12em] text-slate-500 font-semibold mb-3">
            {tr({ en: "Quick Links", hi: "त्वरित लिंक" })}
          </h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services" className="text-slate-700 hover:text-teal-700" data-testid="footer-services">{tr(t.nav.services)}</Link></li>
            <li><Link to="/submit"   className="text-slate-700 hover:text-teal-700" data-testid="footer-submit">{tr(t.nav.submit)}</Link></li>
            <li><Link to="/track"    className="text-slate-700 hover:text-teal-700" data-testid="footer-track">{tr(t.nav.track)}</Link></li>
            <li><Link to="/branches" className="text-slate-700 hover:text-teal-700" data-testid="footer-branches">{tr(t.nav.branches)}</Link></li>
            <li><Link to="/privacy"  className="text-slate-700 hover:text-teal-700" data-testid="footer-privacy">{tr(t.nav.privacy)}</Link></li>
            <li><Link to="/admin/login" className="text-slate-500 hover:text-teal-700" data-testid="footer-admin">{tr(t.nav.admin)}</Link></li>
          </ul>
        </div>

        {BRANCHES.map((b) => (
          <div key={b.key}>
            <h4 className="text-xs uppercase tracking-[0.12em] text-slate-500 font-semibold mb-3">
              {lang === "hi" ? b.name_hi : b.name_en}
            </h4>
            <p className="text-sm text-slate-700 flex items-start gap-2 mb-2">
              <MapPin className="w-4 h-4 mt-0.5 text-teal-700 shrink-0" />
              <span>{lang === "hi" ? b.address_hi : b.address_en}</span>
            </p>
            <p className="text-sm text-slate-700">
              {tr(t.branches.operator)}: <span className="font-medium">{lang === "hi" ? b.operator_hi : b.operator_en}</span>
            </p>
            <a href={`tel:${b.mobile}`} className="mt-2 inline-flex items-center gap-1.5 text-sm text-teal-700 hover:underline" data-testid={`footer-call-${b.key}`}>
              <Phone className="w-4 h-4" /> {b.mobile}
            </a>
          </div>
        ))}
      </div>

      <div className="border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Ashish Point. {tr({ en: "All rights reserved.", hi: "सभी अधिकार सुरक्षित।" })}</div>
          <div>{tr({ en: "Common Service Centre · Bihar", hi: "कॉमन सर्विस सेंटर · बिहार" })}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
